const { smartId } = require('../../tools')
const { getUnknownBatchID } = require('./virtual-batch')

const linesToCounts = (lines) => {
  const counts = {}
  lines.forEach(line => {
    const { sku, amount } = line
    const batchId = getUnknownBatchID(`product:${sku}`)
    counts[batchId] = {
      quantity: amount
    }
  })
  return counts
}

/**
 * Parse JSONB field from Postgres - handles both string and object formats
 */
const parseJsonField = (value) => {
  if (!value) {
    return undefined
  }
  if (typeof value === 'string') {
    try {
      return JSON.parse(value)
    } catch (e) {
      return undefined
    }
  }
  return value
}

const fromRelationalModel = (data) => {
  const { shipment, lines = data.shipment && data.shipment.lines } = data
  const { shipmentNo } = smartId.parse(shipment.shipment_id)
  const snapshotId = `${shipment.shipment_id}:status:${shipment.status}:`

  // Parse JSONB fields from Postgres
  const snapshotDates = parseJsonField(shipment.snapshot_dates)

  // Parse history from Postgres if available
  const history = parseJsonField(shipment.history) || {}

  return {
    shipmentNo,
    id: shipment.shipment_id,
    snapshotId,
    status: shipment.status,
    planningType: shipment.planning_type,
    origin: { id: shipment.origin_id },
    destination: { id: shipment.destination_id },
    orderId: shipment.order_id,
    createdAt: shipment.created_at,
    createdBy: { user: shipment.created_by },
    updatedAt: shipment.updated_at,
    updatedBy: { user: shipment.updated_by },
    comments: shipment.notes ? shipment.notes.split(';').map(comment => {
      const [createdAt, createdBy, commentText] = comment.split(', ')
      return { createdAt, createdBy: { user: createdBy }, comment: commentText }
    }) : [],
    counts: lines ? linesToCounts(lines) : {},
    history,
    funder: { id: shipment.funder_id },
    route: {
      id: shipment.route_id,
      name: shipment.route_name
    },
    programId: shipment.program_id,
    carrierName: shipment.carrier_name,
    snapshotDates,
    driverName: shipment.driver_name
  }
}

module.exports = { fromRelationalModel }
